export default {
  'Aortic enlargement': 'Giãn động mạch chủ',
  'Interstitial lung disease - ILD': 'Dày tổ chức kẽ',
  Atelectasis: 'Xẹp phổi',
  'Nodule/Mass': 'Nốt/ Khối',
  Calcification: 'Vôi hóa',
  Opacity: 'Hình mờ',
  Cardiomegaly: 'Bóng tim to',
  'Other lesion': 'Tổn thường khác',
  'Clavicle fracture': 'Gãy xương đòn',
  'Pleural effusion': 'Tràn dịch màng phổi',
  Consolidation: 'Đông đặc',
  'Pleural thickening': 'Dày màng phổi',
  Emphysema: 'Khí phế thũng',
  Pneumothorax: 'Tràn khí màng phổi',
  'Enlarged PA': 'Giãn động mạch phổi',
  'Pulmonary fibrosis': 'Xơ phổi',
  Infiltration: 'Thâm nhiễm',
  'Rib fracture': 'Gãy xương sườn',
  'Disc space narrowing': 'Hẹp khe đĩa đệm',
  Spondylolysthesis: 'Trượt đốt sống',
  'Foraminal stenosis': 'Hẹp lỗ tiếp hợp',
  'Surgical implant': 'Vật liệu phẫu thuật',
  Osteophytes: 'Gai xương',
  'Vertebral collapse': 'Xẹp đốt sống',
  'Lymph node': 'Hạch',
  Mass: 'Khối',
  'Mediastinal lymph nodes': 'Hạch trung thất',
  'Biliary dilatation': 'Giãn đường mật',
  'Cystic component': 'Tổn thương dạng nang',
  'Arteriovenous malformation': 'Dị dạng thông động tĩnh mạch',
  Gliosis: 'Tăng thần kinh đệm',
  Cavernoma: 'U máu thể hang',
  'Cerebral Atrophy': 'Teo não',
  'Mass/Nodule': 'Nốt/khối',
  'Cerebral Edema': 'Phù não',
  'Mass effect': 'Hiệu ứng khối',
  'CSF-like lesion': 'Tổn thương dịch hóa',
  'Midline shift': 'Đè đẩy đường giữa',
  'Cyst Component': 'Tổn thương dạng nang ',
  'Sinus lesion': 'Tổn thương xoang',
  Demyelination: 'Thoái hóa myelin',
  'Ventricular dilation': 'Giãn não thất',
};
